import React, { useMemo } from 'react';
import MaterialTable from '@material-table/core';
import { connect } from 'react-redux';

import tableColumns from './tableColumns';
import { mapTableOptions } from '../../../consts/tableOptions';
import useTableLocalization from '../../../utils/useTableLocalization';
import { actions as reduxActions } from '../reducers';
import Optional from '../../../utils/optional';
import { isArrayEmpty, isDefined, isUndefined } from '../../../utils/isDefined';
import useLocalTableStore from '../../../utils/useLocalTableStore';
import ConnectionsTableHeader from './ConnectionsTableHeader';
import customTableIcons from '../../../partials/tableIcons/customTableIcons';
import RefreshButton from '../../../partials/tableCustomButtons/RefreshButton';
import ConnectionDetailView from './ConnectionDetailView';

const ConnectionsTable = ({
  connections,
  selectedAccount,
  showTerminated,
  setColumns,
  columns,
  clientName,
  setRefresh
}) => {
  const { localization, language } = useTableLocalization();
  const tableName =
    selectedAccount.value === 'ALL' ? 'Connections2All-1' : 'Connections2-1';
  const tableDefaultColumns = useMemo(() => {
    return tableColumns({
      lang: language,
      showAll: selectedAccount.value === 'ALL'
    });
  }, [language, selectedAccount.value]);

  const {
    pageSize,
    onChangeRowsPerPage,
    onChangeColumnHidden
  } = useLocalTableStore({
    tableName,
    setColumns,
    tableDefaultColumns,
    language,
    tableNameForPageSize: 'Connections'
  });

  const actions = useMemo(
    () => {
      let buttons = [
        {
          icon: () => <RefreshButton tableHeader={true} />,
          onClick: () => setRefresh(true),
          isFreeAction: true
        }
      ];

      return buttons;
    },
    // eslint-disable-next-line
    []
  );

  const dataToShow =
    isDefined(selectedAccount.value) && selectedAccount.value !== 'ALL'
      ? connections
          .filter(
            el =>
              el.account?.externalReference ===
              selectedAccount.externalReference
          )
          .filter(el =>
            showTerminated
              ? el.status === 'TERMINATED'
              : el.status !== 'TERMINATED'
          )
      : connections.filter(el =>
          showTerminated
            ? el.status === 'TERMINATED'
            : el.status !== 'TERMINATED'
        );

  const options = useMemo(() => {
    return {
      ...mapTableOptions({ tableName: 'Network_connections', clientName }),
      selection: false,
      pageSize
    };
  }, [clientName, pageSize]);

  const detailPanel = [
    rowData => ({
      disabled:
        isUndefined(rowData.subproducts) || isArrayEmpty(rowData.subproducts),
      icon: () => (
        <i
          className="fas fa-chevron-right"
          style={{
            display:
              isUndefined(rowData.subproducts) ||
              isArrayEmpty(rowData.subproducts)
                ? 'none'
                : '',
            fontSize: '12px'
          }}
        ></i>
      ),
      openIcon: () => (
        <i
          className="fas fa-chevron-down"
          style={{
            fontSize: '12px'
          }}
        ></i>
      ),
      render: () => (
        <ConnectionDetailView connection={rowData} lang={language} />
      )
    })
  ];

  return (
    <div>
      <MaterialTable
        title={<ConnectionsTableHeader />}
        columns={columns}
        data={dataToShow}
        options={options}
        localization={localization}
        onChangeColumnHidden={onChangeColumnHidden}
        onRowsPerPageChange={onChangeRowsPerPage}
        icons={customTableIcons}
        actions={actions}
        detailPanel={detailPanel}
      />
    </div>
  );
};

const mapStatesToProps = ({ connections, selectClient }) => {
  return {
    ...connections,
    clientName: selectClient.selectedClient.name,
    clientId: selectClient.selectedClient.id
  };
};

const mapDispatchToProps = {
  setColumns: reduxActions.setColumns,
  setRefresh: reduxActions.setRefresh
};

export default connect(mapStatesToProps, mapDispatchToProps)(ConnectionsTable);
